import "../css/navBar.css";
import { useTranslation } from "react-i18next";
import { HashLink as Link } from "react-router-hash-link";
const NavBar = () => {
  const [t] = useTranslation("global");

  return (
    <header className="header">
      {/* <h6 class="textVisit">{t("Header.titleVisit")}</h6> */}

      <nav className="navbar navbar-expand">
        <ul className="navbar-nav">
          <li className="nav-item active">
            {" "}
            <Link
              smooth
              to="#home"
              className="nav-link text-uppercase font-weight-bold"
            >
              {" "}
              {t("Header.linkHome")}{" "}
            </Link>
          </li>
          <li className="nav-item">
            {" "}
            <Link
              smooth
              to="#projects"
              className="nav-link text-uppercase font-weight-bold"
            >
              {" "}
              {t("Header.linkProject")}{" "}
            </Link>
          </li>
          <li className="nav-item">
            {" "}
            <Link
              smooth
              to="#contacts"
              className="nav-link text-uppercase font-weight-bold"
            >
              {" "}
              {t("Header.linkContact")}{" "}
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
};
export default NavBar;
